import { SET_NEW_PERIODS } from './constants'

export default (state = {}, action) => {
    let newState

    switch (action.type) {
        case SET_NEW_PERIODS:
            {
                const { payload } = action

                newState = payload
            }
            break
        default:
            newState = state
            break
    }

    return newState
}
